import React from "react";
import { Box as ChakraBox, Button, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from "react-router-dom";

const BrandTossBox = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/contact");
    window.scrollTo({ top: 0 }); 
  };

  const bg = useColorModeValue('#E8E8E8', '#2D2D2D');
  const color = useColorModeValue('#000000', 'white');

  return (
    <ChakraBox
      bg={bg}
      p={{ base: "10px", md: "40px" }}
      m="auto"
      ml='4%'
      mt={{ base: "30px", md: "51px" }}
      fontFamily="Gil"
      width={{ base: "90%", md: "110%", lg: "90%" }}
      textAlign="center"
      boxShadow="12px 12px #FE3A3A"
      position="relative"
      borderRadius={{ base: "15px", md: "50px" }}
    >
      <VStack spacing={5}>
        <Text
          fontSize={{ base: '22px', md: '50px' }}
          color={color}
        >
          <Text as="span" fontFamily="'Glory', sans-serif">Ready to</Text>
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Toss Your Brand </Text> <br />
          <Text as="span" fontFamily="'Glory', sans-serif">into the Spotlight?</Text>
        </Text>

        <Button
          fontSize={{ base: "lg", md: "22px" }}
          color="white"
          bg="#FE3A3A"
          fontFamily="'Gilroy-SemiBold', sans-serif"
          onClick={handleButtonClick}
          width={{ base: "80%", md: "20%" }}
          height="auto"
          padding={{ base: "8px 0", md: "10px 0" }}
          borderRadius={{ base: "6px", md: "12px" }}
        >
          Contact Us
        </Button>
      </VStack>
    </ChakraBox>
  );
};

export default BrandTossBox;
